var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.dadosCarregados)?_c('div',[_c('b-row',{staticClass:"ml-1"},[_c('b-col',{staticClass:"text-left mb-2",attrs:{"cols":"12"}},[_c('span',[_c('b',[_vm._v("Licitação")])]),_c('br'),_c('span',{staticClass:"pos-left"},[_vm._v(_vm._s(_vm.dadosLicPropria))])])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }